import { Component, OnInit } from '@angular/core';
import { defs } from '../../defs';

@Component({
  selector: 'narwhalia-footer-sidebar',
  templateUrl: './footer-sidebar.component.html',
  styleUrls: ['./footer-sidebar.component.scss']
})
export class FooterSidebarComponent implements OnInit {
	readonly social = defs.social;
  constructor() { }

  ngOnInit() {
  }

}